import React, { useState } from "react";
import {
  StyledMainPageRightSection,
  StyledRightSectionTopTextSection,
  StyledRightSectionTopText
} from "../dashboard/style.dashboard";

import {
  // StyedPackageDestination,
  StyldePackageBodySection,
  StyldePackageType,
  StyledAddPackagePopupSection,
  StyledContentDomesticPackageSection,
  StyledContentInternationalPackageSection,
  StyledHoverIconsandPriceSection,
  StyledHoverIconsSection,
  StyledMaineContentSection,
  StyledPackageAddButton,
  // StyledPackageAddPackageButton,
  StyledPackageBodyGrid,
  // StyledPackageCancelButton,
  StyledPackageDetailsMainTextNameandPrice,
  StyledPackageDetailsSection,
  StyledPackageDiv,
  // StyledPackageDuration,
  // StyledPackageFooterSection,
  StyledPackageHeaderCloseIcon,
  StyledPackageHeaderTitle,
  StyledPackageHeadingAndAddButton,
  StyledPackageHeadingText,
  StyledPackageImg,
  StyledPackageMapingSection,
  StyledPackageName,
  StyledPackageOtherDetails,
  StyledPackagePopup,
  StyledPackagePopupHeader,
  // StyledPackagePrice,
  StyledVisibleIconButton,
} from "./style.tour-packages"

import { Icon } from "@iconify/react";
import Layouts from "../../Layouts/Layouts";



const TourPackages = () => {
  const [openAddPackage, setOpenAddPackage] = useState(false)


  return (
    <Layouts>
      <StyledMainPageRightSection>
        <StyledRightSectionTopTextSection>
          <StyledRightSectionTopText>
            Tour Packages.
          </StyledRightSectionTopText>
        </StyledRightSectionTopTextSection>

        <StyledMaineContentSection>
          <StyledContentDomesticPackageSection>
            <StyledPackageHeadingAndAddButton>
              <StyledPackageHeadingText>Domestic Packages.</StyledPackageHeadingText>
              <StyledPackageAddButton onClick={() => setOpenAddPackage(true)}>+ add package</StyledPackageAddButton>
            </StyledPackageHeadingAndAddButton>
            <StyledPackageMapingSection>
              <StyledPackageDiv>
                <StyledPackageImg src="http://localhost:3003/uploads/packages/69535afd6cb70f566ad87296-photo-0.jpg"></StyledPackageImg>
                <StyledPackageDetailsSection>
                  <StyledPackageDetailsMainTextNameandPrice>kerala backwater bliss</StyledPackageDetailsMainTextNameandPrice>
                  <StyledPackageOtherDetails>kerala * 6 days / 5 Nights</StyledPackageOtherDetails>
                  <StyledHoverIconsandPriceSection>
                    <StyledPackageDetailsMainTextNameandPrice>$99,000</StyledPackageDetailsMainTextNameandPrice>
                    <StyledHoverIconsSection>
                      <StyledVisibleIconButton className="icon-set" color="#2E7D32">
                        <Icon icon="bi:eye-fill" width="20" height="20" />
                      </StyledVisibleIconButton>
                      <StyledVisibleIconButton className="icon-set" color="#1877F2">
                        <Icon icon="ic:sharp-mode-edit" width="20" height="20" />
                      </StyledVisibleIconButton>
                      <StyledVisibleIconButton className="icon-set" color="#E53935">
                        <Icon icon="material-symbols-light:delete" width="20" height="20" />
                      </StyledVisibleIconButton>
                    </StyledHoverIconsSection>
                  </StyledHoverIconsandPriceSection>
                </StyledPackageDetailsSection>
              </StyledPackageDiv>
            </StyledPackageMapingSection>

          </StyledContentDomesticPackageSection>

          <StyledContentDomesticPackageSection>
            <StyledPackageHeadingAndAddButton>
              <StyledPackageHeadingText>International Packages.</StyledPackageHeadingText>
              <StyledPackageAddButton>+ add package</StyledPackageAddButton>
            </StyledPackageHeadingAndAddButton>
            <StyledPackageMapingSection>
              <StyledPackageDiv>
                <StyledPackageImg src="http://localhost:3003/uploads/packages/69535afd6cb70f566ad87296-photo-0.jpg"></StyledPackageImg>
                <StyledPackageDetailsSection>
                  <StyledPackageDetailsMainTextNameandPrice>kerala backwater bliss</StyledPackageDetailsMainTextNameandPrice>
                  <StyledPackageOtherDetails>kerala * 6 days / 5 Nights</StyledPackageOtherDetails>
                  <StyledHoverIconsandPriceSection>
                    <StyledPackageDetailsMainTextNameandPrice>$99,000</StyledPackageDetailsMainTextNameandPrice>
                    <StyledHoverIconsSection>
                      <StyledVisibleIconButton className="icon-set" color="#2E7D32">
                        <Icon icon="bi:eye-fill" width="20" height="20" />
                      </StyledVisibleIconButton>
                      <StyledVisibleIconButton className="icon-set" color="#1877F2">
                        <Icon icon="ic:sharp-mode-edit" width="20" height="20" />
                      </StyledVisibleIconButton>
                      <StyledVisibleIconButton className="icon-set" color="#E53935">
                        <Icon icon="material-symbols-light:delete" width="20" height="20" />
                      </StyledVisibleIconButton>
                    </StyledHoverIconsSection>
                  </StyledHoverIconsandPriceSection>
                </StyledPackageDetailsSection>
              </StyledPackageDiv>
            </StyledPackageMapingSection>

          </StyledContentDomesticPackageSection>


          <StyledContentInternationalPackageSection>

          </StyledContentInternationalPackageSection>
        </StyledMaineContentSection>

      </StyledMainPageRightSection>
      {/** Modal */}
      {
        openAddPackage && (
          <StyledAddPackagePopupSection>

            <StyledPackagePopup>
              <StyledPackagePopupHeader>
                <StyledPackageHeaderTitle>Add Tour Package</StyledPackageHeaderTitle>
                <StyledPackageHeaderCloseIcon><Icon icon="basil:cross-outline" width="32" height="32" /></StyledPackageHeaderCloseIcon>
              </StyledPackagePopupHeader>

              <StyldePackageBodySection>
                <StyledPackageBodyGrid>

                  <StyledPackageName />
                  <StyldePackageType>

                  </StyldePackageType>
                  
                </StyledPackageBodyGrid>
              </StyldePackageBodySection>
              {/* <StyledPackageFooterSection>
                <StyledPackageCancelButton>
                  Cancel
                </StyledPackageCancelButton>
                <StyledPackageAddPackageButton>
                  Add Package
                </StyledPackageAddPackageButton>
              </StyledPackageFooterSection> */}
            </StyledPackagePopup>
          </StyledAddPackagePopupSection>
        )
      }
    </Layouts>
  );
};

export default TourPackages;

